import image1 from '../assets/avatar2.jpg';
import image2 from '../assets/avatar3.jpg';
import image3 from '../assets/avatar5.jpg';
import image4 from '../assets/avatar8.jpg';

export const testimonialsData = [
    {
      image: image1,
      review: "I made the right choice by choosing you and by choosing the rightprogram I already reached many customers!",
      name: 'MATHEW HENDRICKSON',
      status : 'Freelancer'
    },
    {
      image: image2,
      review: "you're the best database SQL programmer.",
      name: 'JOHN KEVIN',
      status: 'Oracle Inc'
    },
    {
      image : image3,
      review:'I appreciate learning with you, thanks a lot for your help.',
      name: ' Mary Dickson',
      status: "ALX, partner"
    },
    {
      image : image4,
      review:'I like how you design the UI they are soft and appealing, You time management skill is on another level. I will always keep in touch.',
      name: 'Frankline Hubson',
      status: "Client, Freelancer"
    }
  ];